import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'app.helmet.title',
    defaultMessage: 'Tribe Academy: Producing Industry-ready Data Practitioners At Scale',
  },
  metaDescription: {
    id: 'app.helmet.meta.description',
    defaultMessage:
      'Tribe Academy is a program focused on producing Industry-ready Data Practitioners at scale.',
  },
  metaOgSiteName: {
    id: 'app.helmet.meta.og.siteName',
    defaultMessage: 'Tribe Academy: Producing Industry-ready Data Practitioners At Scale',
  },
});

const Element = ({ intl: { formatMessage } }) => {
  return (
    <Helmet
      titleTemplate={`%s | ${formatMessage(messages.title)}`}
      defaultTitle={formatMessage(messages.title)}
    >
      <meta name="description" content={formatMessage(messages.metaDescription)} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={formatMessage(messages.title)} />
      <meta property="og:description" content={formatMessage(messages.metaDescription)} />
      <meta property="og:site_name" content={formatMessage(messages.metaOgSiteName)} />
      <meta property="og:image" content={`https://dashboard.tribex.co/tribe-mono-logo.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={formatMessage(messages.title)} />
      <meta name="twitter:description" content={formatMessage(messages.metaDescription)} />
      <meta name="twitter:image" content={`https://dashboard.tribex.co/tribe-mono-logo.png`} />
    </Helmet>
  );
};

export default injectIntl(Element);



// WEBPACK FOOTER //
// ./src/ui/app/helmet.js